import { render } from "./Share.vue?vue&type=template&id=c567f52c&scoped=true"
import script from "./Share.vue?vue&type=script&lang=js"
export * from "./Share.vue?vue&type=script&lang=js"

import "./Share.vue?vue&type=style&index=0&id=c567f52c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c567f52c"]])

export default __exports__